import React from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Wand2, RotateCcw } from 'lucide-react';
import { cn } from '../lib/utils';

export default function QuestionInput({ 
  question, 
  setQuestion, 
  onAsk, 
  onKeyPress, 
  isShaking,
  hasAsked,
  onReset 
}) {
  return (
    <div className="w-full max-w-lg mx-auto space-y-4">
      {/* Input container with glassmorphism */}
      <div className="glass rounded-2xl p-6 space-y-4">
        <label 
          htmlFor="question" 
          className="block text-sm font-medium text-muted-foreground mb-2"
        >
          Ask your question to the mystical orb
        </label>
        
        <div className="relative">
          <Input
            id="question"
            type="text"
            placeholder="Will I find success in my endeavors?"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            onKeyPress={onKeyPress}
            disabled={isShaking}
            className={cn(
              "w-full h-14 px-5 text-base rounded-xl",
              "bg-secondary/50 border-border/50",
              "placeholder:text-muted-foreground/50",
              "focus:border-primary/50 focus:ring-2 focus:ring-primary/20",
              "transition-all duration-300"
            )}
          />
          
          {/* Glowing border effect on focus */}
          <div 
            className="absolute inset-0 rounded-xl pointer-events-none opacity-0 focus-within:opacity-100 transition-opacity"
            style={{
              boxShadow: '0 0 20px hsl(265 72% 58% / 0.2)',
            }}
          />
        </div>

        {/* Action buttons */}
        <div className="flex gap-3">
          <Button
            onClick={onAsk}
            disabled={!question.trim() || isShaking}
            className={cn(
              "flex-1 h-12 text-base font-semibold rounded-xl",
              "bg-gradient-to-r from-primary to-nebula-pink",
              "hover:opacity-90 hover:scale-[1.02]",
              "disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100",
              "shadow-glow transition-all duration-300"
            )}
          >
            {isShaking ? (
              <>
                <span className="animate-pulse">Consulting the cosmos...</span>
              </>
            ) : (
              <>
                <Wand2 className="w-5 h-5 mr-2" />
                Ask the Oracle
              </>
            )}
          </Button>

          {hasAsked && (
            <Button
              onClick={onReset}
              variant="outline"
              className={cn(
                "h-12 px-4 rounded-xl",
                "border-border/50 bg-secondary/30",
                "hover:bg-secondary/50 hover:border-primary/30",
                "transition-all duration-300"
              )}
              title="Ask a new question"
            >
              <RotateCcw className="w-5 h-5" />
            </Button>
          )}
        </div>
      </div>

      {/* Helpful tip */}
      <p className="text-center text-xs text-muted-foreground/60">
        Tip: Ask yes or no questions for the most mystical results
      </p>
    </div>
  );
}
